import React from 'react';
import './style.scss';

export const GenericButton = ({
  classNames = [''],
  styles = {},
  onClick,
  type = 'primary',
  textContent = '',
  disabled = false,
}) => {
  return (
    <button
      className={[
        'cv-generic-button',
        `cv-button-${type}`,
        disabled ? 'disabled' : '',
        ...classNames,
      ].join(' ')}
      type="button"
      onClick={onClick}
      style={styles}
      disabled={disabled}
    >
      {textContent}
    </button>
  );
};

export default GenericButton;
